module.exports = __webpack_public_path__ + "img/nl_get.1477c27.png";